import GeodataApi from '../../api/gen/extObjekty/GeodataApi';
import generateUuid from 'uuid/v4';
import {CachingLoader} from '../../utils';

function loadGeometry(definitionPart) {
    return GeodataApi.getAdresaGeometryByPopis(definitionPart);
}

function resultDataExtractor({status, geometry}) {
    if (status !== 'OK') {
        throw new Error(status || 'Unknonw result status');
    }
    return geometry;
}

function convertGeometryToFeature(geometry) {
    return {
        type: 'Feature',
        id: generateUuid(),
        geometry,
    };
}

/**
 * Utilita pro načtení geometrických dat zákresu na základě textové definice umístění.
 */
export default class GeometryLoader {

    /**
     * Konstruktor.
     *
     * @param {Object} [options] - volitelné parametry
     * @param {function} [options.onLoadStateChange] - callback volaný při změně stavu načítání položek
     * @param {number} [options.loadDelay] - spoždění načítání (debounce)
     */
    constructor(options) {
        this.loader = new CachingLoader(loadGeometry, {...options, resultDataExtractor});
    }

    /**
     * Spustí načítání.
     *
     * @param {string} definition - textová definice umístění
     * @param {boolean} [options.reloadErrors=false] -  příznak, zda vynutit opětovné načtení položek v cache,
     *                                                  u nichž skončilo přechozí načítání chybou
     */
    loadGeometries(definition, options) {
        const definitionParts = definition
            .split(',')
            .map(value => value.trim())
            .filter(Boolean);

        this.loader.loadItems(definitionParts, options);
    }

    /**
     * Otestuje, zda právě probíhá načítání.
     *
     * @returns {boolean} true, pokud se načítá alespoň jedna položka, jinak false
     */
    isLoading() {
        return this.loader.isLoading();
    }

    /**
     * Vrátí načtená geometrická ve formě features s unikátními ID.
     *
     * @returns {Array<Object>} pole features
     */
    getLoadedGeometriesAsFeatures() {
        const features = [];

        for (const geometry of this.loader.getLoadedData()) {
            if (geometry.type === 'GeometryCollection') {
                features.push(...geometry.map(convertGeometryToFeature));
            } else {
                features.push(convertGeometryToFeature(geometry));
            }
        }

        return features;
    }

}
